@charset "UTF-8";

/* projects/speaker-platform/src/app/pages/admin/statistic-admin-validate/statistic-admin-validate.component.scss */
.detailStat {
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  border-radius: 15px;
  padding: 20px;
  background-color: #fff;
  position: relative;
  min-height: 230px;
}
.statslist {
  min-height: 400px;
}
.containe-forTable {
  max-height: 610px;
  overflow-y: auto;
}
.containe-forTable table {
  display: block;
  width: 100%;
}
.containe-forTable thead,
.containe-forTable tbody {
  display: table;
  width: 100%;
  table-layout: fixed;
}
.containe-forTable thead {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;
}
/*# sourceMappingURL=statistic-admin-validate.component-IMWQ6EZB.css.map */
